import { render, staticRenderFns } from "./ItemFilterUtilityFilter.vue?vue&type=template&id=5d135cea&scoped=true"
import script from "./ItemFilterUtilityFilter.vue?vue&type=script&lang=js"
export * from "./ItemFilterUtilityFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d135cea",
  null
  
)

export default component.exports